/* Package JSON Import will be here */
import 'babel-polyfill';
import React, { Fragment } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
// import { LocaleProvider } from 'antd';
// import enUS from 'antd/lib/locale-provider/en_US';
import GoogleAnalytics from 'react-ga';
import { toast } from 'react-toastify';
/* Package JSON Import will be here */

/* Project Import will be here */
import { history, store } from './store';
import { configSettings } from './config/configSettings';
import Routes from './config/route';
//Used to intialize the google api key
/* Project Import will be here */


/* Styles will be here */
// import 'antd/dist/antd.css';
// import 'semantic-ui-css/semantic.min.css';
import 'semantic-ui-less/semantic.less'
// import 'semantic-ui-css/semantic.css';
// import 'react-toastify/dist/ReactToastify.css';
// import 'react-table/react-table.css';
// import 'rc-tooltip/assets/bootstrap_white.css';
/* Styles will be here */

//Disable google analytics tracking on dev
if (!configSettings.isDev) {
    //Initialize Google Analytics
    GoogleAnalytics.initialize(configSettings.googleAnalyticsKey, {
        debug: configSettings.isDev,
        titleCase: false
    });

    history.listen(function (location) {
        //If user signed in then we need to set our reference id as user id in google analytics to view user based report
        let reduxStore = store.getState();
        let userReferenceId = reduxStore.loginReducer.user.userReferenceId;
        if (typeof userReferenceId !== "undefined" && userReferenceId !== null && userReferenceId.trim() !== "") {
            GoogleAnalytics.set({ userId: userReferenceId });
        }
        GoogleAnalytics.ga('set', 'page', location.pathname + location.search);
        GoogleAnalytics.ga('send', 'pageview', location.pathname + location.search);
    });
}

const target = document.querySelector('#root');
toast.configure();
var JavaScriptKey = getJavascriptKey();

function getJavascriptKey() {
    componentRender(JavaScriptKey);
}

function componentRender(JavaScriptKey) {
    render(
        <Fragment>
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <Routes />
                </ConnectedRouter>
            </Provider>
        </Fragment>
        ,
        target
    );
}
